// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-layout-header.nkl-deck-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 50px;
  padding: 0 1rem;
  line-height: 50px;
  z-index: 10;
  background: #fff;
  color: #808080;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.35);
}
.nkl-layout-header.nkl-deck-header.is-hidden {
  display: none;
}
.nkl-layout-header.nkl-deck-header.is-loaded .nkl-deck-user-info {
  opacity: 1;
  transform: translateX(0);
}
.nkl-layout-header.nkl-deck-header.is-loaded .nkl-deck-delegate-text {
  opacity: 1;
  transform: translateY(0);
}
.nkl-layout-header.nkl-deck-header .deck-company-logo,
.nkl-layout-header.nkl-deck-header .deck-logo-placeholder {
  float: left;
  max-height: 36px;
  margin: 7px 24px 7px 0;
  background: rgba(0, 0, 0, 0.3);
}
.nkl-layout-header.nkl-deck-header .deck-company-logo {
  background: transparent;
}
.nkl-layout-header.nkl-deck-header .deck-logo-placeholder {
  height: 36px;
  width: 36px;
  border-radius: 24px;
  background: rgba(0, 0, 0, 0.25);
  animation: fadeInOut 1s infinite;
}
.nkl-layout-header.nkl-deck-header .nkl-deck-delegate-text {
  color: #d93321;
  transition: all 250ms ease-out;
  transform: translateY(-100px);
  opacity: 0;
}
.nkl-layout-header.nkl-deck-header .nkl-deck-user-info {
  float: right;
  opacity: 0;
  transform: translateX(50%);
  transition: all 250ms ease-out;
}
.nkl-layout-header.nkl-deck-header .nkl-deck-user-info button {
  vertical-align: middle;
}
.nkl-layout-header.nkl-deck-header .nkl-deck-user-info .nkl-btn-text:not(.nkl-deck-avatar-btn) {
  padding: 4px 12px;
  color: #808080;
}
.nkl-layout-header.nkl-deck-header .nkl-deck-user-info .nkl-btn-text:hover,
.nkl-layout-header.nkl-deck-header .nkl-deck-user-info .nkl-btn-text:focus {
  background: rgba(0, 0, 0, 0.1);
  border-color: transparent;
}
.nkl-layout-header.nkl-deck-header .nkl-deck-user-info .nkl-typography {
  vertical-align: text-top;
}
.nkl-layout-header.nkl-deck-header.is-loaded .nkl-deck-user-info {
  opacity: 1;
  transform: translateX(0);
}
.nkl-layout-header.nkl-deck-header.is-loaded .nkl-deck-delegate-text {
  opacity: 1;
  transform: translateY(0);
}
.nkl-layout-header.nkl-deck-header .nkl-deck-avatar-btn {
  padding: 0;
  height: 36px;
  width: 36px;
  border: none;
}
.nkl-layout-header.nkl-deck-header .nkl-deck-icon {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  font-size: 24px;
  fill: currentColor;
}
.nkl-layout-header.nkl-deck-header .nkl-deck-icon path {
  fill: currentColor;
}
.nkl-popover.nkl-deck-popover .nkl-popover-inner {
  max-height: 75vh;
  overflow: auto;
}
.nkl-popover.nkl-deck-popover .nkl-deck-popover {
  max-height: none;
  overflow: visible;
}
.nkl-popover.nkl-deck-popover.nkl-deck-popover-menu-container .nkl-popover-inner-content {
  padding: 0;
}
.nkl-popover.nkl-deck-popover .nkl-popover-inner {
  width: auto;
  height: auto;
  border-radius: 16px;
}
.nkl-popover.nkl-deck-popover .nkl-deck-popover-menu {
  border-right: none;
}
.nkl-popover.nkl-deck-popover .nkl-deck-popover-menu a:focus {
  text-decoration: underline;
}
.nkl-popover.nkl-deck-popover .nkl-menu {
  font-size: 16px;
  padding: 15px;
  border-radius: 30px;
}
.nkl-popover.nkl-deck-popover .nkl-menu-item-icon {
  min-width: 24px;
  font-size: 24px;
}
.nkl-popover.nkl-deck-popover .nkl-menu-item svg {
  margin-right: 12px;
  width: 24px;
  fill: currentColor;
  vertical-align: text-bottom;
}
.nkl-popover.nkl-deck-popover .nkl-layout-sider {
  background: #fff;
}
.nkl-popover.nkl-deck-popover .nkl-layout-sider-trigger {
  display: none;
}
.nkl-popover.nkl-deck-popover .nkl-layout-sider-has-trigger {
  padding-bottom: 0;
}
.nkl-popover.nkl-deck-popover .nkl-layout-sider-has-trigger .ant-menu-inline {
  border-right: none;
}
#deckNotificationsPopoverBtn .ant-badge {
  margin-left: 2px;
}
@keyframes fadeInOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
